import { IWithWorksheetInjectedProps } from 'Components/Worksheets/Core';
import React from 'react';
import { NamePrefixModifier, withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import AsLiquidLimitCuringSection from '../LiquidLimitCuringSection';
import LiquidLimitEquipmentDetailsSection from '../LiquidLimitEquipmentDetailsSection';
import AsLiquidLimitFourPointDeterminationSection from './LiquidLimitFourPointDeterminationSection';
import AsLiquidLimitFourPointResultsSection from './LiquidLimitFourPointResultsSection';

let AsLiquidLimitFourPointSection: React.FC<IWithWorksheetInjectedProps> = () => {
  return (
    <>
      <NamePrefixModifier appendNamePrefix="LiquidLimit">
        <LiquidLimitEquipmentDetailsSection />
        <AsLiquidLimitCuringSection />
        <AsLiquidLimitFourPointDeterminationSection />
      </NamePrefixModifier>
      <AsLiquidLimitFourPointResultsSection />
    </>
  );
};

AsLiquidLimitFourPointSection = withInjectedProps(AsLiquidLimitFourPointSection);

export { AsLiquidLimitFourPointSection };
export default AsLiquidLimitFourPointSection;
